'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactIntl = require('react-intl');

var _FlatButton = require('material-ui/FlatButton');

var _FlatButton2 = _interopRequireDefault(_FlatButton);

var _Dialog = require('material-ui/Dialog');

var _Dialog2 = _interopRequireDefault(_Dialog);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var _class = function (_React$Component) {
  _inherits(_class, _React$Component);

  function _class() {
    _classCallCheck(this, _class);

    return _possibleConstructorReturn(this, (_class.__proto__ || Object.getPrototypeOf(_class)).apply(this, arguments));
  }

  _createClass(_class, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          content = _props.content,
          cancel = _props.cancel,
          submit = _props.submit,
          onRequestClose = _props.onRequestClose,
          onCancel = _props.onCancel,
          onSubmit = _props.onSubmit,
          others = _objectWithoutProperties(_props, ['content', 'cancel', 'submit', 'onRequestClose', 'onCancel', 'onSubmit']);

      var actions = [];

      if (cancel) {
        actions.push(_react2.default.createElement(_FlatButton2.default, {
          label: _react2.default.createElement(_reactIntl.FormattedMessage, {
            id: 'CLOSE',
            description: 'Close dialog',
            defaultMessage: 'Close'
          }),
          secondary: true,
          onTouchTap: onCancel
        }));
      }

      if (submit) {
        actions.push(_react2.default.createElement(_FlatButton2.default, {
          label: _react2.default.createElement(_reactIntl.FormattedMessage, {
            id: 'SEND',
            description: 'Confirm button to close dialog',
            defaultMessage: 'Send'
          }),
          primary: true,
          onTouchTap: onSubmit
        }));
      }

      return _react2.default.createElement(
        _Dialog2.default,
        _extends({
          actions: actions,
          onRequestClose: onRequestClose
        }, others),
        content,
        this.props.children
      );
    }
  }]);

  return _class;
}(_react2.default.Component);

_class.propTypes = {
  children: _react2.default.PropTypes.any,
  content: _react2.default.PropTypes.string,
  cancel: _react2.default.PropTypes.bool,
  submit: _react2.default.PropTypes.bool,
  onRequestClose: _react2.default.PropTypes.func,
  onCancel: _react2.default.PropTypes.func,
  onSubmit: _react2.default.PropTypes.func
};
exports.default = _class;


/*****************
 ** WEBPACK FOOTER
 ** ./~/@its/components/lib/Presentational components/Dialog/Dialog.js
 ** module id = 173
 ** module chunks = 0
 **/